import GameConfig from "../config";
import * as THREE from "three";

export default class SceneUtils {
    static resize(scene){
        if(!scene || !scene.game || !scene.game.threeCamera || scene.scale.isFullscreen) return;
        const threeDiv = document.getElementById("three-app");
        const phaserDiv = document.getElementById("phaser-app");
        let canvasPhaser = phaserDiv.children[0];
        let canvasThree = threeDiv.children[0];
        canvasThree.style.height = canvasPhaser.style.height;
        canvasThree.style.width = canvasPhaser.style.width;
        canvasThree.style.marginTop = canvasPhaser.style.marginTop;
        canvasThree.style.marginLeft = canvasPhaser.style.marginLeft;
        threeDiv.style = phaserDiv.style;

        const width = parseInt(canvasThree.style.width.substr(0, canvasThree.style.width.length -2));
        const height = parseInt(canvasThree.style.height.substr(0, canvasThree.style.height.length -2));
        scene.game.threeCamera.aspect = width / height;
        scene.game.threeCamera.updateProjectionMatrix();
        scene.game.threeRenderer.setSize( width, height);
    }

    static startFullscreen(scene){
        if(window.top){
            window.top.postMessage('fullscreenRequest', '*');
            this.resize(scene);
        } else {
            console.log("no parent window. fullscreen request ignored")
        }
    }

    static resetThree(scene){
        scene.traverse(c => {
            if(c.geometry) c.geometry.dispose();
            if(c.texture) c.texture.dispose();
        })
        scene.remove.apply(scene, scene.children);
        if(scene && scene.renderer) scene.renderer.clear(new THREE.Color(0,0,0));
    }
}